export const sortingData = {
  ConfigCarat: [{ title: "Name" }, { title: "From" }],
  ConfigMatchData: [{ title: "Date" }, { title: "Shape" }],
  collectiondata: [{ title: "Date" }, { title: "Collection Name" }],
  colunmSetting: [{ title: "Width" }, { title: "Name" }],
  volumediscount: [{ title: "Discount" }, { title: "From" }],
  rapConfig: [{ title: "Rap ID" }, { title: "Password" }],
};
